export default {"src":"/_next/static/media/outer-2.3bc04f38.svg","height":74,"width":74,"blurWidth":0,"blurHeight":0};